import { render, staticRenderFns } from "./EventCreateModal.vue?vue&type=template&id=631bbd58"
import script from "./EventCreateModal.vue?vue&type=script&lang=js"
export * from "./EventCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports